<template>
    <a :href="target" class="user js-ga-event"
       data-page-area="header"
       data-type="link"
       data-name="user"
       data-action="href"
       :data-destination-url="target"
    >
        <Popper :content="tooltipText" hover arrow>
            <img src="/img/icons/user.svg" v-svg-inline>
        </Popper>
    </a>
</template>

<script>
import Popper from 'vue3-popper'

export default {

    props: [
        'target',
        'tooltipText'
    ],

    components: {
        Popper
    }
}
</script>
